import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _availability = { timestampRangesOptions: '_timestampRangesOptions' };
var _availableRange = {
    startTime: 'google.protobuf.Timestamp',
    endTime: 'google.protobuf.Timestamp',
};
var _bulkMenuOrderingSettingsResult = {
    menuOrderingSettings: '_menuOrderingSettings',
};
var _bulkUpdateMenuOrderingSettingsRequest = {
    menusOrderingSettings: '_maskedMenuOrderingSettings',
};
var _bulkUpdateMenuOrderingSettingsResponse = {
    results: '_bulkMenuOrderingSettingsResult',
};
var _bulkUpdateMenuOrderingSettingsTagsByFilterRequest = {};
var _bulkUpdateMenuOrderingSettingsTagsByFilterResponse = {};
var _bulkUpdateMenuOrderingSettingsTagsRequest = {};
var _bulkUpdateMenuOrderingSettingsTagsResponse = {};
var _createMenuOrderingSettingsRequest = {
    menuOrderingSettings: '_menuOrderingSettings',
};
var _createMenuOrderingSettingsResponse = {
    menuOrderingSettings: '_menuOrderingSettings',
};
var _deleteMenuOrderingSettingsRequest = {};
var _deleteMenuOrderingSettingsResponse = {};
var _getMenuOrderingSettingsRequest = {};
var _getMenuOrderingSettingsResponse = {
    menuOrderingSettings: '_menuOrderingSettings',
};
var _getRestaurantsAppClonesStatusRequest = {};
var _getRestaurantsAppClonesStatusResponse = {};
var _listMenusAvailabilityStatusRequest = { timeSlot: '_timeSlot' };
var _listMenusAvailabilityStatusResponse = {};
var _maskedMenuOrderingSettings = {
    mask: 'google.protobuf.FieldMask',
    menuOrderingSettings: '_menuOrderingSettings',
};
var _menuOrderingSettings = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    availability: '_availability',
};
var _queryMenuOrderingSettingsRequest = {};
var _queryMenuOrderingSettingsResponse = {
    menuOrderingSettings: '_menuOrderingSettings',
};
var _timeSlot = {
    startTime: 'google.protobuf.Timestamp',
    endTime: 'google.protobuf.Timestamp',
};
var _timestampRangesOptions = { ranges: '_availableRange' };
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = {
    menuOrderingSettings: '_menuOrderingSettings',
};
var _updateMenuOrderingSettingsRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    menuOrderingSettings: '_menuOrderingSettings',
};
var _updateMenuOrderingSettingsResponse = {
    menuOrderingSettings: '_menuOrderingSettings',
};
var _upsertMenuOrderingSettingsByMenuIdRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    menuOrderingSettings: '_menuOrderingSettings',
};
var _upsertMenuOrderingSettingsByMenuIdResponse = {
    menuOrderingSettings: '_menuOrderingSettings',
};
function resolveWixRestaurantsMenuSettingsV1MenuOrderingSettingsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
        _base_domain_: [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/menu-ordering-settings',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/menu-ordering-settings',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/menu-ordering-settings',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a menu ordering settings entity. */
export function createMenuOrderingSettings(payload) {
    var _a = serializer(_createMenuOrderingSettingsRequest, {
        _availability: _availability,
        _availableRange: _availableRange,
        _menuOrderingSettings: _menuOrderingSettings,
        _timestampRangesOptions: _timestampRangesOptions,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createMenuOrderingSettingsResponse, {
        _availability: _availability,
        _availableRange: _availableRange,
        _menuOrderingSettings: _menuOrderingSettings,
        _timestampRangesOptions: _timestampRangesOptions,
    }).fromJSON;
    function __createMenuOrderingSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menu_settings.v1.menu_ordering_settings',
            method: 'POST',
            methodFqn: 'wix.restaurants.menu_settings.v1.MenuOrderingSettingsService.CreateMenuOrderingSettings',
            url: resolveWixRestaurantsMenuSettingsV1MenuOrderingSettingsServiceUrl({
                protoPath: '/v1/menu-ordering-settings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createMenuOrderingSettings.fromReq = fromReq;
    __createMenuOrderingSettings.__isAmbassador = true;
    return __createMenuOrderingSettings;
}
/** Retrieves a menu ordering settings entity. */
export function getMenuOrderingSettings(payload) {
    var _a = serializer(_getMenuOrderingSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMenuOrderingSettingsResponse, {
        _availability: _availability,
        _availableRange: _availableRange,
        _menuOrderingSettings: _menuOrderingSettings,
        _timestampRangesOptions: _timestampRangesOptions,
    }).fromJSON;
    function __getMenuOrderingSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menu_settings.v1.menu_ordering_settings',
            method: 'GET',
            methodFqn: 'wix.restaurants.menu_settings.v1.MenuOrderingSettingsService.GetMenuOrderingSettings',
            url: resolveWixRestaurantsMenuSettingsV1MenuOrderingSettingsServiceUrl({
                protoPath: '/v1/menu-ordering-settings/{menuOrderingSettingsId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMenuOrderingSettings.fromReq = fromReq;
    __getMenuOrderingSettings.__isAmbassador = true;
    return __getMenuOrderingSettings;
}
/**
 * Upserts a menu ordering settings entity for a given `menuId`.
 * Try to create a menu ordering settings, in case it already exists - update the menu ordering settings
 */
export function upsertMenuOrderingSettingsByMenuId(payload) {
    var _a = serializer(_upsertMenuOrderingSettingsByMenuIdRequest, {
        _availability: _availability,
        _availableRange: _availableRange,
        _menuOrderingSettings: _menuOrderingSettings,
        _timestampRangesOptions: _timestampRangesOptions,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_upsertMenuOrderingSettingsByMenuIdResponse, {
        _availability: _availability,
        _availableRange: _availableRange,
        _menuOrderingSettings: _menuOrderingSettings,
        _timestampRangesOptions: _timestampRangesOptions,
    }).fromJSON;
    function __upsertMenuOrderingSettingsByMenuId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menu_settings.v1.menu_ordering_settings',
            method: 'POST',
            methodFqn: 'wix.restaurants.menu_settings.v1.MenuOrderingSettingsService.UpsertMenuOrderingSettingsByMenuId',
            url: resolveWixRestaurantsMenuSettingsV1MenuOrderingSettingsServiceUrl({
                protoPath: '/v1/menu-ordering-settings/upsert/menu-id/{menuOrderingSettings.menuId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __upsertMenuOrderingSettingsByMenuId.fromReq = fromReq;
    __upsertMenuOrderingSettingsByMenuId.__isAmbassador = true;
    return __upsertMenuOrderingSettingsByMenuId;
}
/**
 * Updates a menu ordering settings entity.
 *
 * Each time the menu ordering settings entity is updated, `revision` increments by 1. The current `revision` must be specified when updating the menu ordering settings entity.
 * This ensures you're working with the latest entity and prevents unintended overwrites.
 */
export function updateMenuOrderingSettings(payload) {
    var _a = serializer(_updateMenuOrderingSettingsRequest, {
        _availability: _availability,
        _availableRange: _availableRange,
        _menuOrderingSettings: _menuOrderingSettings,
        _timestampRangesOptions: _timestampRangesOptions,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMenuOrderingSettingsResponse, {
        _availability: _availability,
        _availableRange: _availableRange,
        _menuOrderingSettings: _menuOrderingSettings,
        _timestampRangesOptions: _timestampRangesOptions,
    }).fromJSON;
    function __updateMenuOrderingSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menu_settings.v1.menu_ordering_settings',
            method: 'PATCH',
            methodFqn: 'wix.restaurants.menu_settings.v1.MenuOrderingSettingsService.UpdateMenuOrderingSettings',
            url: resolveWixRestaurantsMenuSettingsV1MenuOrderingSettingsServiceUrl({
                protoPath: '/v1/menu-ordering-settings/{menuOrderingSettings.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMenuOrderingSettings.fromReq = fromReq;
    __updateMenuOrderingSettings.__isAmbassador = true;
    return __updateMenuOrderingSettings;
}
/**
 * Deletes a menu ordering settings entity.
 * Deleting an entity permanently removes it from the menu ordering settings list.
 */
export function deleteMenuOrderingSettings(payload) {
    var _a = serializer(_deleteMenuOrderingSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMenuOrderingSettingsResponse, {}).fromJSON;
    function __deleteMenuOrderingSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menu_settings.v1.menu_ordering_settings',
            method: 'DELETE',
            methodFqn: 'wix.restaurants.menu_settings.v1.MenuOrderingSettingsService.DeleteMenuOrderingSettings',
            url: resolveWixRestaurantsMenuSettingsV1MenuOrderingSettingsServiceUrl({
                protoPath: '/v1/menu-ordering-settings/{menuOrderingSettingsId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteMenuOrderingSettings.fromReq = fromReq;
    __deleteMenuOrderingSettings.__isAmbassador = true;
    return __deleteMenuOrderingSettings;
}
/**
 * Retrieves a list of menu ordering settings entities given the specified paging, filtering, and sorting. Up to 100 entities can be returned per request.
 *
 * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/menu-ordering-settings/sorting-and-filtering) article. To learn how to query menu ordering settings entities, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 */
export function queryMenuOrderingSettings(payload) {
    var _a = serializer(_queryMenuOrderingSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMenuOrderingSettingsResponse, {
        _availability: _availability,
        _availableRange: _availableRange,
        _menuOrderingSettings: _menuOrderingSettings,
        _timestampRangesOptions: _timestampRangesOptions,
    }).fromJSON;
    function __queryMenuOrderingSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menu_settings.v1.menu_ordering_settings',
            method: 'POST',
            methodFqn: 'wix.restaurants.menu_settings.v1.MenuOrderingSettingsService.QueryMenuOrderingSettings',
            url: resolveWixRestaurantsMenuSettingsV1MenuOrderingSettingsServiceUrl({
                protoPath: '/v1/menu-ordering-settings/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMenuOrderingSettings.fromReq = fromReq;
    __queryMenuOrderingSettings.__isAmbassador = true;
    return __queryMenuOrderingSettings;
}
/**
 * Updates multiple menu ordering settings entities at once.
 * Each time a menu ordering settings entity is updated, `revision` increments by 1. The existing revision must be specified when updating the menu ordering settings entity. This ensures you're working with the entity's latest information, and it prevents unintended overwrites.
 */
export function bulkUpdateMenuOrderingSettings(payload) {
    var _a = serializer(_bulkUpdateMenuOrderingSettingsRequest, {
        _availability: _availability,
        _availableRange: _availableRange,
        _maskedMenuOrderingSettings: _maskedMenuOrderingSettings,
        _menuOrderingSettings: _menuOrderingSettings,
        _timestampRangesOptions: _timestampRangesOptions,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateMenuOrderingSettingsResponse, {
        _availability: _availability,
        _availableRange: _availableRange,
        _bulkMenuOrderingSettingsResult: _bulkMenuOrderingSettingsResult,
        _menuOrderingSettings: _menuOrderingSettings,
        _timestampRangesOptions: _timestampRangesOptions,
    }).fromJSON;
    function __bulkUpdateMenuOrderingSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menu_settings.v1.menu_ordering_settings',
            method: 'POST',
            methodFqn: 'wix.restaurants.menu_settings.v1.MenuOrderingSettingsService.BulkUpdateMenuOrderingSettings',
            url: resolveWixRestaurantsMenuSettingsV1MenuOrderingSettingsServiceUrl({
                protoPath: '/v1/bulk/menu-ordering-settings/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateMenuOrderingSettings.fromReq = fromReq;
    __bulkUpdateMenuOrderingSettings.__isAmbassador = true;
    return __bulkUpdateMenuOrderingSettings;
}
/**
 * Retrieves a list of a menu's availability statuses for a given time slot and restaurant operation. (See the Restaurants Operations API for more information.)
 * Returns the availability status for the given time slot per menu.
 */
export function listMenusAvailabilityStatus(payload) {
    var _a = serializer(_listMenusAvailabilityStatusRequest, { _timeSlot: _timeSlot }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMenusAvailabilityStatusResponse, {}).fromJSON;
    function __listMenusAvailabilityStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menu_settings.v1.menu_ordering_settings',
            method: 'GET',
            methodFqn: 'wix.restaurants.menu_settings.v1.MenuOrderingSettingsService.ListMenusAvailabilityStatus',
            url: resolveWixRestaurantsMenuSettingsV1MenuOrderingSettingsServiceUrl({
                protoPath: '/v1/menu-ordering-settings/menus-availability-status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMenusAvailabilityStatus.fromReq = fromReq;
    __listMenusAvailabilityStatus.__isAmbassador = true;
    return __listMenusAvailabilityStatus;
}
/** Updates extended fields of a menu ordering settings entity without incrementing its revision. */
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {
        _availability: _availability,
        _availableRange: _availableRange,
        _menuOrderingSettings: _menuOrderingSettings,
        _timestampRangesOptions: _timestampRangesOptions,
    }).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menu_settings.v1.menu_ordering_settings',
            method: 'POST',
            methodFqn: 'wix.restaurants.menu_settings.v1.MenuOrderingSettingsService.UpdateExtendedFields',
            url: resolveWixRestaurantsMenuSettingsV1MenuOrderingSettingsServiceUrl({
                protoPath: '/v1/menu-ordering-settings/{id}/update-extended-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
/**
 * Retrieves the clone status of the restaurants apps.
 * In case of uninstalling an app, the clone status will not be changed.
 * For internal use of the service only.
 */
export function getRestaurantsAppClonesStatus(payload) {
    var _a = serializer(_getRestaurantsAppClonesStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRestaurantsAppClonesStatusResponse, {}).fromJSON;
    function __getRestaurantsAppClonesStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menu_settings.v1.menu_ordering_settings',
            method: 'GET',
            methodFqn: 'wix.restaurants.menu_settings.v1.MenuOrderingSettingsService.GetRestaurantsAppClonesStatus',
            url: resolveWixRestaurantsMenuSettingsV1MenuOrderingSettingsServiceUrl({
                protoPath: '/v1/menu-ordering-settings/restaurants-app-clones-status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRestaurantsAppClonesStatus.fromReq = fromReq;
    __getRestaurantsAppClonesStatus.__isAmbassador = true;
    return __getRestaurantsAppClonesStatus;
}
/**
 * Synchronously update tags on multiple menu ordering settings entities.
 * If you specify a tag in both `assignTags` and `unassignTags`, it is assigned.
 */
export function bulkUpdateMenuOrderingSettingsTags(payload) {
    var _a = serializer(_bulkUpdateMenuOrderingSettingsTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateMenuOrderingSettingsTagsResponse, {}).fromJSON;
    function __bulkUpdateMenuOrderingSettingsTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menu_settings.v1.menu_ordering_settings',
            method: 'POST',
            methodFqn: 'wix.restaurants.menu_settings.v1.MenuOrderingSettingsService.BulkUpdateMenuOrderingSettingsTags',
            url: resolveWixRestaurantsMenuSettingsV1MenuOrderingSettingsServiceUrl({
                protoPath: '/v1/bulk/menu-ordering-settings/update-tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateMenuOrderingSettingsTags.fromReq = fromReq;
    __bulkUpdateMenuOrderingSettingsTags.__isAmbassador = true;
    return __bulkUpdateMenuOrderingSettingsTags;
}
/**
 * Asynchronously update tags on multiple menu ordering settings entities according to the specified filter.
 * If a filter isn't specified, this method updates all menu ordering settings entities.
 * If you specify a tag in both `assignTags` and `unassignTags`, it is assigned.
 */
export function bulkUpdateMenuOrderingSettingsTagsByFilter(payload) {
    var _a = serializer(_bulkUpdateMenuOrderingSettingsTagsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateMenuOrderingSettingsTagsByFilterResponse, {}).fromJSON;
    function __bulkUpdateMenuOrderingSettingsTagsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menu_settings.v1.menu_ordering_settings',
            method: 'POST',
            methodFqn: 'wix.restaurants.menu_settings.v1.MenuOrderingSettingsService.BulkUpdateMenuOrderingSettingsTagsByFilter',
            url: resolveWixRestaurantsMenuSettingsV1MenuOrderingSettingsServiceUrl({
                protoPath: '/v1/bulk/menu-ordering-settings/update-tags-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateMenuOrderingSettingsTagsByFilter.fromReq = fromReq;
    __bulkUpdateMenuOrderingSettingsTagsByFilter.__isAmbassador = true;
    return __bulkUpdateMenuOrderingSettingsTagsByFilter;
}
//# sourceMappingURL=http.impl.js.map